import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import UpdateNotification from './components/PWA/UpdateNotification';
import OfflineIndicator from './components/PWA/OfflineIndicator';
import ErrorBoundary from './components/common/ErrorBoundary';
import { AuthProvider, useAuth } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import './App.css';

// Componente de pantalla de carga con branding ITURRI palpitante
const LoadingScreen = () => (
  <div className="fixed inset-0 bg-white flex flex-col items-center justify-center z-50">
    <div className="flex flex-col items-center animate-pulse">
      <img 
        src="https://assets.brandbay.io/brands/1736547941865x394131539339247600/assets/OX3X76ITURRI_YourSafetyMatters.jpg" 
        alt="Cargando..." 
        className="w-24 h-auto mb-4 object-contain"
      />
      <p className="text-slate-400 text-xs font-bold tracking-widest uppercase">Cargando miniGIV...</p>
    </div>
  </div>
);

// Componente para proteger rutas privadas
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) return <LoadingScreen />;
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Contenido principal de la aplicación
const AppContent = () => {
  const { user, loading } = useAuth();

  if (loading) return <LoadingScreen />;

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans selection:bg-red-100 selection:text-red-900">
      <Routes>
        {/* Ruta de Login: Redirige al Dashboard si ya está autenticado */}
        <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
        
        {/* Rutas Protegidas: Dashboard y sus sub-rutas */}
        <Route 
          path="/dashboard/*" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* Redirecciones por defecto */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      
      <UpdateNotification />
      <OfflineIndicator />
    </div>
  );
};

/**
 * Componente Raíz de la Aplicación
 */
function App() {
  return (
    <HashRouter>
      <ErrorBoundary>
        <AuthProvider>
          <DataProvider>
            <AppContent />
          </DataProvider>
        </AuthProvider>
      </ErrorBoundary>
    </HashRouter>
  );
}

export default App;